export type LoginRequest = {
	username: string;
	password: string;
};

export type LoginResponse = {
	token: string;
	district_manager_id: number | null;
	reseller_manager_id: number | null;
	reseller_id: number | null;
	is_tenant: boolean;
	logo: string | null;
	primary_color: string;
	secondary_color: string;
	hide_electricity: boolean;
	source_type: "qundis" | "advant" | null;
	deployment_tool_enabled: boolean;
};

export type User = Omit<LoginResponse, "token"> & {
	username: string;
};

export type UserRole =
	| "admin"
	| "district_manager"
	| "reseller_manager"
	| "reseller"
	| "end_user";

export function getUserRole(user: User): UserRole {
	const roleIdCount =
		(user.district_manager_id ? 1 : 0) +
		(user.reseller_manager_id ? 1 : 0) +
		(user.reseller_id ? 1 : 0);
	if (roleIdCount >= 2) return "admin";
	if (user.district_manager_id) return "district_manager";
	if (user.reseller_manager_id) return "reseller_manager";
	if (user.reseller_id) return "reseller";
	if (user.is_tenant) return "end_user";
	return "end_user";
}

export function hasDeploymentToolEnabled(user: User | null): boolean {
	if (!user) return false;
	if (user.deployment_tool_enabled !== true) return false;
	return getUserRole(user) === "district_manager";
}
